import { apiClient } from '@/api/client';
import logger from '@/utils/logger';
import type { OrderingState, ProductResponse } from '../types/api/product';

export const getProducts = async (
  page: number = 1,
  pageSize: number = 10,
  ordering: OrderingState,
  filters?: Record<string, string>,
): Promise<ProductResponse> => {
  const queryFilters = { ...filters };
  const searchParams = new URLSearchParams();

  // 기본 파라미터
  searchParams.append('page', page.toString());
  searchParams.append('page_size', pageSize.toString());
  searchParams.append(
    'ordering',
    `${ordering.direction === 'desc' ? '-' : ''}${ordering.field}`,
  );

  // 검색 파라미터 : TODO 별도 파라미터로 분리
  const search = queryFilters?.['search'];
  if (search) {
    searchParams.append('search', search);
    delete queryFilters?.search;
  }

  // 필터 파라미터
  logger.info('++ queryFilters', queryFilters);
  Object.entries(queryFilters || {}).forEach(([key, value]) => {
    if (value) {
      searchParams.append(`${key}__in`, value);
    }
  });

  const response = await apiClient.get<ProductResponse>(
    `/products?${searchParams.toString()}`,
  );
  return response.data;
};
